<template>
  <div class="position-relative">
    <loading :active="isLoading" :is-full-page="false" color="blue" loader="spinner"></loading>

    <template v-if="items.length > 0">
      <efficiency-tests-table
        :items="items"
        :columns="columns"
        @sort-changed="onSortingChanged"
        @refresh="loadTests"
      ></efficiency-tests-table>

      <div v-if="pagination.items > pagination.perPage" class="d-flex justify-content-end mt-3">
        <b-pagination
          class="mb-0"
          :value="pagination.currentPage"
          :total-rows="pagination.items"
          :per-page="pagination.perPage"
          @change="onChangeCurrentPage"
        ></b-pagination>
      </div>
    </template>
    <no-content
      v-else-if="!loading"
      :icon-name="'exclamation-circle'"
      :icon-class="['mb-3', 'fa-3x']"
      :text="$t('efficiencyTestsList.noContent')"
    ></no-content>

    <div v-if="product" class="d-flex justify-content-end my-3">
      <b-button size="sm" variant="primary" @click="createNewTest">
        {{ $t('efficiencyTestsList.createNewTest') }}
      </b-button>
    </div>
  </div>
</template>

<script>
// Efficiency tests of the product shown in the detail page: same table/row actions as
// EfficiencyTestsList.vue (via EfficiencyTestsTable.vue) but ISIN-scoped, no filters and fewer
// columns. List state is local on purpose — the efficiencyTestsList store module backs the list
// page's own filters/pagination, which this must not overwrite.
import EfficiencyTestsTable from '../EfficiencyTests/EfficiencyTestsTable.vue'
import NoContent from '../Lib/NoContent.vue'
import { post as _post } from '../../utils/fetcher'

export default {
  components: {
    EfficiencyTestsTable,
    NoContent,
  },

  props: {
    isin: {
      type: String,
      required: true,
    },
    // Product in test for "+ Nuovo Test di Efficienza" — same shape EfficiencyTestsList.vue's
    // onProductPicked stores in efficiencyTestsCommon/setSelectedProduct (productId, name,
    // issuerCode, referenceDate, characteristics). Null hides the button.
    product: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      columns: ['name', 'lastUpdatedAt', 'status', 'outcome', 'insight', 'actions'],
      items: [],
      loading: false,
      sortingValue: '',
      pagination: {
        perPage: 10,
        currentPage: 1,
        items: 0,
      },
    }
  },

  computed: {
    // Execute/delete from the shared table drive efficiencyTestsCommon's loading flag.
    isLoading() {
      return this.loading || this.$store.getters['efficiencyTestsCommon/getLoading']
    },
  },

  watch: {
    isin() {
      this.pagination.currentPage = 1
      this.loadTests()
    },
  },

  methods: {
    loadTests() {
      this.loading = true
      return _post('/api/efficiencyTests/search', {
        Sf: '',
        Isin: this.isin,
        Status: null,
        Outcome: null,
        Page: this.pagination.currentPage,
        Size: this.pagination.perPage,
        Sort: this.sortingValue,
      })
        .then((data) => {
          this.pagination = {
            perPage: data.paging.pageSize,
            currentPage: data.paging.pageIndex,
            items: data.paging.totalItems,
          }
          this.items = (data.efficiencyTests || []).map((item) => ({ ...item, scoringProfileId: item.id }))
        })
        .catch((err) => {
          this.httpErrorsHandler(err)
        })
        .finally(() => {
          this.loading = false
        })
    },

    onSortingChanged(val) {
      this.sortingValue = val
      this.pagination.currentPage = 1
      this.loadTests()
    },

    onChangeCurrentPage(value) {
      this.pagination.currentPage = value
      this.loadTests()
    },

    // Same hand-off as EfficiencyTestsList.vue's onProductPicked, minus the product picker and the
    // extra /api/detail-page/product call: this page already has the product loaded.
    createNewTest() {
      this.$store.dispatch('efficiencyTestsCommon/setSelectedProduct', { ...this.product })
      this.$store.dispatch('efficiencyTestsCommon/newScoringProfile')
      this.$router.push({ name: 'efficiencyTestsCreate', query: { productId: this.product.productId } })
    },
  },

  created() {
    this.loadTests()
  },
}
</script>
